import React from "react";
import {
  TextField,
  Typography,
  Card,
  Checkbox,
  Scrollbar,
  Button,
  Tag,
} from "@ann/web-components";
import {
  SlideoutHeader,
  SlideoutSubHeader,
  SlideoutToolsContainer,
  ToolsSection,
  ToolsGrid,
  ToolCardContainer,
  ToolCardContent,
  ToolCardHeader,
  ToolCardDescription,
} from "./SlideoutTools.styled";

const InitialToolsView = ({
  searchQuery,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  categories,
  tools,
  selectedTools,
  onToolSelection,
  onToolConfiguration,
}) => {
  const safeTools = Array.isArray(tools) ? tools : [];

  const getTagProps = (tool) => {
    if (!tool.tag) return null;
    
    return {
      text: tool.tag,
      color: tool.tagColor || "default",
      size: "small",
      onClose: undefined,
    };
  };

  return (
    <>
      <SlideoutHeader>
        <SlideoutSubHeader>
          <Typography category="title" size="large" weight="bold">
            Tools Library
          </Typography>
          <Typography category="body" size="medium" weight="regular">
            Explore and manage tools to extend your agent's capabilities.
          </Typography>
        </SlideoutSubHeader>
        <TextField
          onChange={onSearchChange}
          size="medium"
          iconLeft="search"
          placeholder="Search tools..."
          value={searchQuery}
        />
      </SlideoutHeader>

      <Scrollbar size="small">
        <SlideoutToolsContainer>
          <ToolsSection>
            <ToolsGrid>
              {safeTools.map((tool) => {
                const safeId = tool?.action_uuid ?? tool?.id ?? tool?.name;
                const safeTitle =
                  tool?.name ?? tool?.label ?? tool?.title ?? "";
                const safeDesc = tool?.description ?? "";

                return (
                  <Card 
                    key={safeId}
                    onClick={() => onToolSelection(safeId)}
                  >
                    <ToolCardContainer>
                      <Checkbox
                        onChange={(e) => {
                          e.stopPropagation();
                          onToolSelection(safeId);
                        }}
                        size="small"
                        checked={selectedTools.includes(safeId)}
                      />
                      <ToolCardContent>
                        <ToolCardHeader>
                          <Typography
                            category="subtitle"
                            size="medium"
                            weight="bold"
                          >
                            {safeTitle}
                          </Typography>
                        </ToolCardHeader>
                        <ToolCardDescription>
                          <Typography
                            category="body"
                            size="small"
                            weight="regular"
                          >
                            {safeDesc}
                          </Typography>
                        </ToolCardDescription>
                        {tool.tag && (
                          <Tag {...getTagProps(tool)} />
                        )}
                      </ToolCardContent>
                      <Button
                        icon="settings"
                        size="medium"
                        type="secondary"
                        onClick={(e) => {
                          e.stopPropagation();
                          onToolConfiguration(tool);
                        }}
                        disabled={!selectedTools.includes(safeId)}
                      />
                    </ToolCardContainer>
                  </Card>
                );
              })}
            </ToolsGrid>
          </ToolsSection>
        </SlideoutToolsContainer>
      </Scrollbar>
    </>
  );
};

export default InitialToolsView;

